module.exports = __webpack_public_path__ + "img/17_66.08dcb870.png";